// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3bSS1","amount":"Amount_amount__2uRK1","tip":"Amount_tip__NUkK5","tipHeader":"Amount_tipHeader__3fHIC","tipsWrap":"Amount_tipsWrap__O32zl"};